import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import InfoButton from "@/components/Header/Button/InfoButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList/HeaderButtonList";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import Info from "@/features/InterventionTemplates/Info";
import InterventionTemplateEdit from "@/features/InterventionTemplates/InterventionTemplateEdit";
import { useAuthorization } from "@/modules/authorization";
import { InterventionTemplateDuplicateButton } from "@/modules/intervention-template/intervention-template-duplicate";
import { useSidePanel } from "@/modules/side-panel";
import { StateEditForm } from "@/modules/state-edit-form";
import { EditButton } from "@/ui/edit-button";

const HeaderButtons = ({ template = {} }) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canCreateModel, canUpdateItem, canDeleteItem } = useAuthorization();

  const onInfoSelect = () => {
    openSidePanel({
      title: template.name,
      component: <Info template={template} />,
    });
  };

  const onEditClick = () => {
    openSidePanel({
      title: t("interventionTemplate:form.edit.label"),
      component: <InterventionTemplateEdit templateId={template.id} />,
    });
  };

  const primaryActions = [];
  primaryActions.push(
    <StateEditForm
      key={BUTTON_KEYS.STATE_EDIT}
      stateType="interventionTemplate"
      model={template}
    />
  );

  primaryActions.push(<InfoButton key="info" onInfoSelect={onInfoSelect} />);

  const secondaryActions = [];
  if (canUpdateItem(template)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canCreateModel("interventiontemplate")) {
    secondaryActions.push({
      key: BUTTON_KEYS.DUPLICATE,
      label: (
        <InterventionTemplateDuplicateButton
          key={BUTTON_KEYS.DUPLICATE}
          template={template}
          type="text"
          showIcon
        />
      ),
    });
  }

  if (canDeleteItem(template)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          modelKey="interventiontemplate"
          titleType="interventionTemplate"
          model={template}
          buttonProps={{
            type: BUTTON_TYPE.TEXT,
            disabled: !template.is_deletable,
          }}
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};

HeaderButtons.propTypes = {
  template: PropTypes.object.isRequired,
};

export default HeaderButtons;
